// @flow
/* eslint-disable import/prefer-default-export */
import { ApiBase } from 'api/api'
import { makeGetRequest } from 'api/fetchCalls'
import type { QuestionResponse } from 'types/question'

export async function getQuestions(
  { formId }: { formId: string | void },
  requestParams: { signal?: AbortSignal } = {}
): Promise<QuestionResponse> {
  if (!formId) {
    return Promise.resolve({
      count: 0,
      next: null,
      previous: null,
      results: [],
    })
  }
  return await makeGetRequest(
    ApiBase + `/questions?form=${formId}`,
    requestParams
  )
}
